<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('preInvoice.printByClass') }}</h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('preInvoice.filter') }}</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="row form-group">
                  <label class="col-md-4 col-form-label">{{
                    $t('preInvoice.subProgram')
                  }}</label>
                  <div class="col-md-8">
                    <treeselect
                      :clearable="false"
                      :load-options="subOptionsAction"
                      :options="subOptions"
                      :placeholder="$t('select')"
                      v-model="model.acps_id"
                      @select="subSelect"
                    />
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-4 col-form-label">{{
                    $t('preInvoice.level')
                  }}</label>
                  <div class="col-md-8">
                    <treeselect
                      :clearable="false"
                      :options="levelOptions"
                      :placeholder="$t('select')"
                      v-model="model.level_id"
                      @select="levelSelect"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row form-group">
                  <label class="col-md-4 col-form-label required">{{
                    $t('preInvoice.gradeName')
                  }}</label>
                  <div class="col-md-8">
                    <treeselect
                      :clearable="false"
                      :options="gradeOptions"
                      :placeholder="$t('select')"
                      v-model="model.grade_id"
                    />
                    <div class="validate" v-if="errors.has('grade_id')">
                      {{ errors.first('grade_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-12 text-right">
                    <ts-button
                      color="primary"
                      @click="printByGrade"
                      :waiting="printing"
                      >{{ $t('preInvoice.preview') }}</ts-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <br />
        <div id="container">
          <i class="fa fa-spinner spin fa-2x" v-if="printing"></i>
          <iframe :src="src" v-if="!printing"></iframe>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'pdfByGradePreInvoice',
  data() {
    return {
      model: {
        acps_id: null,
        level_id: null,
        grade_id: null
      },
      printing: false,
      src: '',
      subOptions: null,
      levelOptions: [],
      gradeOptions: [],
      errors: new Errors()
    }
  },
  methods: {
    ...mapActions('preInvoice', [
      'getGradeByLevel',
      'getSubProgram',
      'getLevel'
    ]),
    async subOptionsAction({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        let response = await this.getSubProgram({
          page: -1,
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          }
        })
        this.subOptions = response.data.map(el => ({
          id: el.acps_id,
          label: el.acps_name_foreign
        }))
      }
    },
    subSelect(value) {
      this.model.level_id = null
      this.model.grade_id = null
      this.getLevel({
        page: -1,
        filter: {
          acps_id: value.id
        }
      }).then(response => {
        this.levelOptions = response.data.map(el => ({
          id: el.level_id,
          label: el.level_name_foreign
        }))
      })
    },
    levelSelect(value) {
      this.model.grade_id = null
      this.getGradeByLevel({
        page: -1,
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        filter: {
          level_id: value.id
        }
      }).then(response => {
        this.gradeOptions = response.data.map(el => ({
          id: el.grade_id,
          label: el.grade_name_foreign
        }))
      })
    },
    printByGrade() {
      this.errors = new Errors()
      this.printing = true
      this.$store
        .dispatch('preInvoice/printByGrade', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.printing = false
        })
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 60vh;
  background: black;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 60vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
}
</style>
